import classNames from "classnames/bind";
import NewRecordFont from "images/IPX/Runnerz/ipx_runnerz_icon_new_01.png";
import styles from "./index.module.scss";

const cn = classNames.bind(styles);

function Record({currentRecord, bestRecord}) {
  return (
    <div className={cn("runnerz_record")}>
      <div className={cn("game_result")}>LAP TIME</div>
      <div className={cn("lap_time")}>
        <img alt="new record" src={NewRecordFont} />
        <div>{currentRecord}</div>
      </div>
      <div className={cn("my_record")}>
        <div>BEST RECORD</div>
        <div>{bestRecord}</div>
      </div>
    </div>
  );
}

export default Record;
